export default "__VITE_ASSET__Cz5h14wU__"